//对底层数据进行封装

//引入底层的数据接口
import request from '@/helpers/request'

//与后端约定的路由接口
const URL = {
  REGISTER: '/auth/register',
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  GET_INFO: '/auth'
}

//导出一个对象
export default {
  register({username, password}) {
    return request(URL.REGISTER, 'POST', { username, password })
  },

  login({username, password}) {
    return request(URL.LOGIN, 'POST', { username, password })
  },

  logout() {
    return request(URL.LOGOUT)
  },

  getInfo() {
    return request(URL.GET_INFO)
  }
}


// WEBPACK FOOTER //
// ./src/api/auth.js